<template>
  <!-- Progressive disclosure: md shows Perf Tools + Search, lg adds Dashboard, xl shows all -->
  <div id="header-links" class="hidden md:flex relative ml-auto items-baseline gap-4">
    <router-link
      v-if="!isSettingViewOnly"
      :to="{ name: 'reservationsDashboardLive' }"
      id="venue-dashboard"
      class="link text-fg-primary font-heading text-lg font-normal hidden lg:block"
      active-class="underline underline-offset-4"
    >
      Dashboard
    </router-link>
    <PerformanceToolsLink
      v-if="!isSettingViewOnly"
      id="venue-performance-tools"
      class="link text-fg-primary font-heading text-lg font-normal"
    >
      Performance Tools
    </PerformanceToolsLink>
    <template v-if="!isSettingViewOnly">
      <router-link
        :to="{ name: RESIDENCY_ROUTE_NAMES_NEW.LIST }"
        id="venue-residencies"
        class="link text-fg-primary font-heading text-lg font-normal hidden xl:block"
        active-class="underline underline-offset-4"
      >
        Residencies
      </router-link>
    </template>
    <template v-if="!isSettingViewOnly">
      <router-link
        :to="{ name: SHOWS_ROUTE_NAMES.LIST }"
        id="venue-shows"
        class="link text-fg-primary font-heading text-lg font-normal hidden xl:block"
        active-class="underline underline-offset-4"
        >Shows</router-link
      >
    </template>
    <template v-if="isOwner">
      <router-link
        v-if="!isSettingViewOnly"
        :to="{ name: MAILCHIMP_ROUTE_NAMES.TEMPLATE_EDIT }"
        id="mailchimp-template-edit"
        class="link text-fg-primary font-heading text-lg font-normal hidden xl:block"
        active-class="underline underline-offset-4"
      >
        Marketing
      </router-link>
      <router-link
        v-if="!isSettingViewOnly"
        :to="{ name: REPORT_ROUTE_NAMES.PERFORMANCES }"
        id="venue-reports"
        class="link text-fg-primary font-heading text-lg font-normal hidden xl:block"
        active-class="underline underline-offset-4"
      >
        Reporting
      </router-link>
    </template>
    <VenueSearchMenu class="mr-4" />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { MAILCHIMP_ROUTE_NAMES } from '@/modules/mailchimp/constants/MailchimpRouteNames'
import PerformanceToolsLink from '@/modules/performance/components/atoms/PerformanceToolsLink.vue'
import { REPORT_ROUTE_NAMES } from '@/modules/report/constants/ReportRouteNames'
import { RESIDENCY_ROUTE_NAMES_NEW } from '@/modules/residency/constants/ResidencyRouteNames'
import { SHOWS_ROUTE_NAMES } from '@/modules/show/constants/ShowRouteName'
import VenueSearchMenu from '@/modules/venueUi/components/organisms/VenueSearchMenu.vue'
import { useSettingStore } from '@/stores/setting'
import { useUserStore } from '@/stores/user'

const settingStore = useSettingStore()
const { isSettingViewOnly } = storeToRefs(settingStore)

const userStore = useUserStore()
const { isOwner } = storeToRefs(userStore)
</script>
